var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import clsx from "clsx";
import { FooterItemType } from "../../../types/footer";
import { ItemButton } from "./ItemButton";
import { ItemImage } from "./ItemImage";
import { ItemLink } from "./ItemLink";
import { ItemText } from "./ItemText";
import { isValidItem } from "./helpers";
import { getMemberExtraClassNames } from "../../../helpers/getMemberExtraClassNames";
var solveItemComponent = function (props) {
    var type = props.type;
    switch (type) {
        case FooterItemType.Link:
            return React.createElement(ItemLink, __assign({}, props));
        case FooterItemType.Text:
            return React.createElement(ItemText, __assign({}, props));
        case FooterItemType.Image:
            return React.createElement(ItemImage, __assign({}, props));
        case FooterItemType.Button:
            return React.createElement(ItemButton, __assign({}, props));
        default:
            return null;
    }
};
export var Item = function (props) {
    var isValid = isValidItem(props);
    if (!isValid) {
        return null;
    }
    var extraClassNames = getMemberExtraClassNames(props.extraOptions);
    var className = clsx(props.className, extraClassNames);
    return solveItemComponent(__assign(__assign({}, props), { className: className }));
};
//# sourceMappingURL=Item.js.map